import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";
import Image from "../Image/Image";

interface Props extends Component {
  label: string;
  logoUrl?: string;
}

const GearBrandHeading = ({ classNames = [], label, logoUrl = "" }: Props) => {
  const fallbackLabel = <strong className="GearBrandHeading__label">{label}</strong>;

  return (
    <div className={cn("GearBrandHeading", [], classNames)}>
      {logoUrl ? (
        <div className="GearBrandHeading__logo">
          <Image src={logoUrl} alt={label} fallbackContent={fallbackLabel} fill position="center" />
        </div>
      ) : (
        fallbackLabel
      )}
    </div>
  );
};

export default GearBrandHeading;
